import { module } from 'modujs'
import { createApp, reactive, watch, computed } from 'vue/dist/vue.esm-bundler.js'
import { VInputSelect } from '../vue/components'
import { VUE_SETTINGS } from '../config'

export default class extends module {
    constructor(m) {
        super(m);

        // DOM
        this.$el = this.el

        // Vars
        this.baseUrl = this.getData('baseurl')
    }

    init() {

        this.vueApp = createApp({
            ...VUE_SETTINGS,
            components: {
                VInputSelect,
            },
            setup: () => {

                // Variables
                const currentParameters = new URLSearchParams(window.location.search)
                const sportCategory = reactive({
                    $model: currentParameters.get('sport') || ''
                })
                const achievementLevel = reactive({
                    $model: currentParameters.get('achievement') || ''
                })
                const show = reactive({
                    $model: currentParameters.get('show') || ''
                })

                // Computed
                const parameters = computed(() => ({
                    sport: sportCategory.$model,
                    achievement: achievementLevel.$model,
                    show: show.$model,
                }))

                // Watchers
                watch(parameters, newParameters => {
                    let url = this.baseUrl

                    const params = Object.keys(newParameters).filter(k => newParameters[k] !== '').map(k => `${k}=${newParameters[k]}`).join('&')

                    if(params) {
                        url += `?${params}`
                    }

                    this.call('goTo', { url }, 'Load')
                })

                return {
                    sportCategory,
                    achievementLevel,
                    show,
                }
            }
        })
        this.vueApp.mount(this.$el)
    }

    destroy() {
        this.vueApp?.unmount()
    }
}
